import React, { PropsWithChildren } from 'react'
import { Box, Text, Button, Flex } from 'pcln-design-system'
import PropTypes, { InferProps } from 'prop-types'
import BannerWrapper from './BannerWrapper'
import IconRightContainer from './IconRightContainer'
import BoxToFlex from './BoxToFlex'

const bannerProps = {
  /** Optional (Node) icon on the positioned on the left side of the banner */
  iconLeft: PropTypes.node,
  /** Optional (Node) icon on the positioned on the right side of the banner */
  iconRight: PropTypes.node,
  /** Optional (Text) text displayed beneath the (optional) heading */
  text: Text,
  /** Optional (Text) text displayed above the (optional) text */
  heading: Text,
  /** Optional (String) background color for the banner */
  bgColor: PropTypes.string,
  /** Optional (String) color of a thick "hug" border at the top of the banner */
  borderHugTop: PropTypes.string,
  /** Optional (String) color of a thick "hug" border at the left side of the banner */
  borderHugLeft: PropTypes.string,
  /** Optional (String) color of a 1px border around the entire banner */
  outline: PropTypes.string,
  /** Optional (Button) button positioned on the right side of the banner */
  buttonRight: Button,
  /** Optional (string - xs, sm, md, lg, xl, xxl)
   * mediaQuery rightButton displays beneath text below and inline above */
  buttonRightBreakPoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  /** Optional (Node) Image positioned on the left side of the banner */
  imageLeft: PropTypes.node,
  /** Optional (string) preconfigured style option */
  variation: PropTypes.string,
  /** Optional (string - sm, md, lg, xl) */
  boxShadowSize: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
}

type bannerType = InferProps<typeof bannerProps>

const Banner = ({
  text,
  heading,
  imageLeft,
  iconLeft,
  outline,
  bgColor,
  buttonRight,
  buttonRightBreakPoint,
  iconRight,
  borderHugTop,
  borderHugLeft,
  boxShadowSize,
}: PropsWithChildren<bannerType>) => (
  <BannerWrapper
    py={imageLeft ? 0 : 3}
    outline={outline}
    bgColor={bgColor}
    borderHugTop={borderHugTop}
    borderHugLeft={borderHugLeft}
    boxShadowSize={boxShadowSize}
    borderRadius='xl'
  >
    <Flex justifyContent='flex-start' alignItems='center'>
      {!!imageLeft && imageLeft}
      {!!iconLeft && iconLeft}
      <BoxToFlex
        data-testid='bannerContents'
        buttonRightBreakPoint={buttonRightBreakPoint}
        width={1}
        justifyContent='flex-start'
        alignItems='center'
        pr={[2, null, null, 0]}
      >
        <Box px={2}>
          {!!heading && heading}
          {!!text && text}
        </Box>
        {buttonRight && (
          <Box ml='auto' mr={3} pl={2}>
            {buttonRight}
          </Box>
        )}
      </BoxToFlex>
    </Flex>
    {iconRight && <IconRightContainer>{iconRight}</IconRightContainer>}
  </BannerWrapper>
)

export default Banner
